import { Option } from '@organisms/Select'
import { Course } from './course'
import { File } from './file'
import { BaseApiResponse } from './common'
import { CourseThemeType } from './myCourse'

export type Scorm = {
  id: string
  title: string
  file: File
  scormDirectory: string
  currentVote: ScormVotes | null
  courseChapterThemes: CourseChapterTheme[]
  scormType: 'ispring' | 'articulate'
  type: CourseThemeType
  badVotes: number
  excellentVotes: number
  goodVotes: number
  views: number
} & BaseApiResponse

export type CourseChapterTheme = {
  id: number
  title: string
  courseTheme: string
  courseChapter: CourseChapter
} & BaseApiResponse

type CourseChapter = {
  id: number
  title: string
  hoursCount: number
  course: Course
  themesCount: number
} & BaseApiResponse

export type ScormListItemServerResponse = {
  id: string
  title: string
} & BaseApiResponse

export type ScormListItem = ScormListItemServerResponse & Option

export type CommonScormBody = {
  title: string
  file: string
}

export type CreateScormBody = CommonScormBody & {
  course?: string
  type?: CourseThemeType
}

export type UpdateScormBody = CommonScormBody & {
  id: string
  type?: CourseThemeType
}

export type VoteScormBody = {
  id: string
  rank: ScormVotes
}

export enum ScormVotes {
  BAD = 'bad',
  GOOD = 'good',
  EXCELLENT = 'excellent',
}
